// DEV settings
export const MAX_USER_DATA_AGE = 1000 * 60 * 2; // Two minutes

export const LOCAL_STORAGE_USER_DATA_KEY = 'local-storage-user-data-key';
export const LOCAL_STORAGE_PROGRAM_ID_KEY = 'local-storage-program-id-key';
export const LOCAL_STORAGE_MOBILE_DIALOG_DISMISSED_KEY = 'local-storage-mobile-dialog-dismissed-key';
